import { useMemo } from 'react';
import { useGetVersionComparisonsQuery } from '../api';
export const useVersionComparisons = (params) => {
    const { data: response, isLoading, isFetching, isError, error, } = useGetVersionComparisonsQuery(params);
    return useMemo(() => {
        const count = response?.count ?? 0;
        const comparisons = response?.results ?? [];
        const next = response?.next;
        const previous = response?.previous;
        return { comparisons, count, next, previous, isLoading, isFetching, isError, error };
    }, [response, isLoading, isFetching, isError, error]);
};
